<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-16 13:10:47
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-21 12:18:15
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/component-nsjb.vue
 * @Description: 描述
-->
<template>
  <div class="nsjb">
    <div class="content" v-loading="loading.nsjb">
      <div class="scroll-list" style="height: 90px" v-if="!loading.nsjb">
        <vue-seamless-scroll
          :class-option="classOption"
          :data="nsjb"
          v-if="nsjb.length > 3"
        >
          <div class="list-item" v-for="(item, index) in nsjb" :key="index">
            <el-row :gutter="14">
              <el-col :span="8" class="text-overflow">{{ item.zylm }}</el-col>
              <el-col :span="8" class="text-overflow">{{ item.fbsj }}</el-col>
              <el-col :span="8" class="text-overflow">{{ item.czsj }}</el-col>
            </el-row>
          </div>
        </vue-seamless-scroll>
        <template v-else>
          <div class="list-item" v-for="(item, index) in nsjb" :key="index">
            <el-row :gutter="14">
              <el-col :span="8" class="text-overflow">{{ item.zylm }}</el-col>
              <el-col :span="8" class="text-overflow">{{ item.fbsj }}</el-col>
              <el-col :span="8" class="text-overflow">{{ item.czsj }}</el-col>
            </el-row>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('production-management', ['loading', 'nsjb']),
    classOption () {
      return {
        limitMoveNum: true,
        // 速度
        step: 1,
        // 鼠标停止
        hoverStop: true,
        // 0 下 1 上 2 左 3 右
        direction: 1,
        singleHeight: 30,
        waitTime: 5000
      }
    }
  },
  methods: {
    ...mapActions('production-management', ['getNSJB'])
  },
  created () {
    this.getNSJB()
  }
}
</script>

<style lang="scss">
.nsjb {
  padding-top: 52px;
  .content {
    height: 100%;
    position: relative;
    margin: 0 auto;
    width: calc(100% - 50px);
    .scroll-list {
      overflow: hidden;
      .list-item {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
